import React, { FC } from 'react';

import { SeturIcon } from '@components/utils/CustomIcon';

import { Container } from './styled';
import ScrollLink from './Link';

export interface TabItems {
  key: string;
  title: string;
  icon?: SeturIcon;
}

export interface TabProps {
  tabs: TabItems[];
}

const Tab: FC<TabProps> = ({ tabs }) => (
  <Container>
    {tabs.map((tab) => (
      <ScrollLink key={tab.key} className={tab.key} to={tab.key}>
        {tab.title}
      </ScrollLink>
    ))}
  </Container>
);

export default Tab;
